import { useBudgetSync } from "../usage/hooks/useBudgetSync";

import type { ReactNode } from "react";

const AppDataSync = () => {
  useBudgetSync();
  return null;
};

export const AppDataProvider = ({ children }: { children: ReactNode }) => (
  <>
    <AppDataSync />
    {children}
  </>
);
